import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import Container from '@material-ui/core/Container';

import { mySiteActions } from '../../modules/mySite';
import { authenticationActions } from '../../modules/authentication';
import { ROLE, roles } from '../../constants';
import { history } from '../../helpers';
import Popup from '../Dialog/Popup';
import { Navigation } from '../Common';

class AppShell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opbOpen: false,
            contentsOpen: false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mySite !== this.props.mySite) {
            const mySiteID = localStorage.getItem("mySiteID") || 0;
            if (!mySiteID) {
                localStorage.setItem("mySiteID", this.props.mySite.mySiteID);
                this.props.setMySiteID(mySiteID);
            }
        }
    }

    handleSiteIDChange = (e) => {
        const mySiteID = parseInt(e.target.value) || 0;
        if (mySiteID) {
            localStorage.setItem("mySiteID", mySiteID);
            this.props.setMySiteID(mySiteID);
            history.push("/opbstate", { siteID: mySiteID });
        }
    };
    setOpen = (name, isOpen) => {
        this.setState({
            [name]: isOpen
        });
    };
    handleOpen = (name) => {
        this.setOpen(name, true);
    };
    handleClose = (name) => {
        this.setOpen(name, false);
    };
    handleClick = (e) => {
        e.preventDefault();
        history.push("/contentsAllMng");
    };
    render() {
        const { alert, children, user, myInfo, mySite } = this.props;
        const mySiteID = localStorage.getItem("mySiteID");
        const portalAccess = sessionStorage.getItem("portalAccess") || "N" // 포털을 통한 로그인(portalAccess.js) 시 sessionStorage에 "Y" 저장

        return (
            <>
                {this.props.pathName && this.props.pathName.filter(path => path === "Display화면편집").length === 1
                    ?
                    <>
                        <div>
                            {alert.message &&
                                <Popup message={alert.message} stateRefresh={this.props.stateRefresh} />
                            }
                            {React.cloneElement(children)}
                        </div>
                    </>
                    :
                    <>
                        <Navbar bg="dark" variant="dark" expand="lg">
                            {user && myInfo && myInfo.myRole.dashboard !== ROLE.NONE
                                ?
                                <Navbar.Brand as={Link} to="/dashboard" className="smartopb-brand">Smart Display</Navbar.Brand>
                                :
                                <Navbar.Brand as={Link} to={{ pathname: "/opbstate", state: { siteID: (mySite && mySiteID) } }} className="smartopb-brand">Smart Display</Navbar.Brand>
                            }
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="mr-auto">
                                    {user && myInfo && myInfo.myRole.dashboard !== ROLE.NONE
                                        ?
                                        <Nav.Link as={Link} to="/dashboard">Home</Nav.Link>
                                        :
                                        <Nav.Link as={Link} to={{ pathname: "/opbstate", state: { siteID: (mySite && mySiteID) } }}>Home</Nav.Link>
                                    }
                                    {!user
                                        ?
                                        <Nav.Link as={Link} to="/login">Display 관리</Nav.Link>
                                        :
                                        <NavDropdown className="dropdown-toggle" title="Display 관리" id="basic-nav-dropdown" show={this.state.open} onMouseEnter={() => { this.handleOpen('opbOpen'); }} onMouseLeave={() => { this.handleClose('opbOpen'); }}>
                                            {user && myInfo && myInfo.myRole.opbMng !== ROLE.NONE &&
                                                <NavDropdown.Item as={Link} to="/opbmng">Display 관리</NavDropdown.Item>
                                            }
                                            {user && myInfo && myInfo.myRole.opbMng === ROLE.NONE &&
                                                <NavDropdown.Item as={Link} to={{ pathname: "/opbstate", state: { siteID: (myInfo && mySiteID) } }}>Display 관리</NavDropdown.Item>
                                            }
                                            {user && myInfo && myInfo.myRole.firmwareMng !== ROLE.NONE &&
                                                <NavDropdown.Item as={Link} to="/firmwareMng">즉시 패치 관리</NavDropdown.Item>
                                            }
                                            {user && myInfo && myInfo.myRole.firmwareMng !== ROLE.NONE &&
                                                <NavDropdown.Item as={Link} to="/firmwareMngDerv">예약 패치 관리</NavDropdown.Item>
                                            }
                                        </NavDropdown>
                                    }
                                    {!user
                                        ?
                                        <Nav.Link as={Link} to="/login">컨텐츠 관리</Nav.Link>
                                        :
                                        <NavDropdown className="dropdown-toggle" title="컨텐츠 관리" id="basic-nav-dropdown" show={this.state.open} onMouseEnter={() => { this.handleOpen('contentsOpen'); }} onMouseLeave={() => { this.handleClose('opbOpen'); }}>
                                            {user && myInfo && myInfo.myRole.contentsAllMng === ROLE.WRITE &&
                                                <NavDropdown.Item as={Link} to="/contentsAllMng">현장컨텐츠관리</NavDropdown.Item>
                                            }
                                            {user && myInfo && myInfo.myRole.templateMng === ROLE.WRITE &&
                                                <NavDropdown.Item as={Link} to="/templateMng">템플릿등록관리</NavDropdown.Item>
                                            }
                                            {user && myInfo && myInfo.myRole.contentsMng === ROLE.WRITE &&
                                                <NavDropdown.Item as={Link} to={{ pathname: "/contentsMng", state: { boardTypeCode: "BK001" } }}>통합 컨텐츠 관리</NavDropdown.Item>
                                            }
                                            {/* TODO: 공지사항 관련은 추후 작업 내용으로 주석처리함.
                                            {user && myInfo && myInfo.myRole.noticeMng === ROLE.WRITE &&
                                                <NavDropdown.Item as={Link} to={{ pathname: "/noticeMng", state: { boardTypeCode: "BK002" } }}>공지사항 관리</NavDropdown.Item>
                                            }
                                            */}
                                        </NavDropdown>
                                    }
                                    {user && myInfo && myInfo.myRole.codeMng !== ROLE.NONE &&
                                        <Nav.Link as={Link} to="/codemng">코드관리</Nav.Link>
                                    }
                                    {user && myInfo && myInfo.myRole.boardinfoMng !== ROLE.NONE &&
                                        <Nav.Link as={Link} to="/boardinfo">통합게시판관리</Nav.Link>
                                    }
                                </Nav>
                                <div className="auth">
                                    {user && myInfo &&
                                        (myInfo.myRole !== roles.userRole
                                            ?
                                            <div className="user-info">
                                                <img src="/assets/images/ic-user.svg" className="ic-user" alt="user icon" />
                                                <>{myInfo.userName + '(' + myInfo.userID + ')님'}</>
                                            </div>
                                            : mySite.mySiteList.length !== 0
                                                ?
                                                <div className="user-info">
                                                    <select className="w100per" value={mySiteID} onChange={this.handleSiteIDChange}>
                                                        {mySite.mySiteList && mySite.mySiteList.length > 0 && mySite.mySiteList.map(site => {
                                                            return <option key={site.siteID} value={site.siteID}>{`${site.siteNum}_${site.siteName}`}</option>;
                                                        })}
                                                    </select>
                                                </div>
                                                : <></>
                                        )
                                    }
                                    {portalAccess === "N" &&
                                    <div className="login">
                                        {user ?
                                            <Nav.Link as={Link} to="/login"><img src="/assets/images/ic-lock.svg" className="ic-lock" alt="Log out" />Log-out</Nav.Link>
                                            :
                                            <Nav.Link as={Link} to="/login"><img src="/assets/images/ic-lock.svg" className="ic-lock" alt="Log in" />Log-in</Nav.Link>
                                        }
                                    </div>
                                    }
                                </div>
                            </Navbar.Collapse>
                        </Navbar>
                        <main className="content-wrapper">
                            <Container maxWidth="lg">
                                {alert.message &&
                                    <Popup message={alert.message} stateRefresh={this.props.stateRefresh} />
                                }
                                {this.props.pathName &&
                                    <Navigation pathName={this.props.pathName} />
                                }
                                {React.cloneElement(children)}
                                {/*<Copyright />*/}
                            </Container>
                        </main>
                    </>
                }
            </>
        );
    }
}

function mapState(state) {
    const { authentication, alert, userinfo, mySite } = state;
    const { user } = authentication;
    const myInfo = userinfo.item;
    return { alert, user, myInfo, mySite };
}

const actionCreators = {
    setMySiteID: mySiteActions.setMySiteID,
    logout: authenticationActions.logout
};

export default connect(mapState, actionCreators)(AppShell);

